<template>
	<div :class="$style.footer">
    <!-- <div class="ewm" style="padding-bottom: 15px;">
      <dl style="display: inline-block; padding: 0 30px;">
        <dt><img src="@/assets/images/ewm_android.png" height="120" /></dt>
        <dd>Android版下载</dd>
      </dl> -->
      <!--dl style="display: inline-block; padding: 0 30px;">
        <dt><img src="@/assets/images/ewm_ios.png" height="120" /></dt>
        <dd>iPhone版下载</dd>
      </dl-->
    <!-- </div> -->
    <h4>Copyright &copy;{{toyear}} 上海仪表电子专业技术人员（专业科目）继续教育网络学习平台 保留所有权利。</h4>
    <h4>沪ICP备16000405号</h4>
    <h4>如需帮助 联系管理员: 18930299913 或 minq.ydwl@inesa-it.com</h4>
	</div>
</template>
<script>
  import config from '@/config'
  import api from '@/api'
  import containerLogout from '@/containers/auth/containerLogout'
  import containerUser from '@/containers/auth/containerUser'
  import containerRoles from '@/containers/auth/containerGetRoles'
  import { getCookie } from '@/store/cookies.js'
  export default {
    data () {
      return {
        toyear: new Date().getFullYear()
      }
    }
  }
</script>
<style module>
	.footer {
    padding: 20px 0;
		text-align: center;
		font-size: 12px;
		color: #2b2b2b;
		background: #f2f2f2;
    font-family:arial;
	}
  .android{ text-align:center; position:absolute;top:90px;right:0;color:#ddd; line-height:40px;}
  .ios{ text-align:center; position:absolute;top:90px;right:130px;color:#ddd; line-height:40px;}
</style>



// WEBPACK FOOTER //
// src/pages/others/footer.vue